import { createContext } from 'react';

export const FormStateContext = createContext(undefined);

export const FormStateContextProvider = FormStateContext.Provider;
